export const GET_PRODUCTS = 'providers/menuMaker/Products/GET_PRODUCTS';
export const CREATE_PRODUCT = 'providers/menuMaker/Products/CREATE_PRODUCT';
export const TOGGLE_PRODUCT_AVAILABILITY = 'providers/menuMaker/Products/TOGGLE_PRODUCT_AVAILABILITY';
export const DUPLICATE_PRODUCT = 'providers/menuMaker/Products/DUPLICATE_PRODUCT';
export const DELETE_PRODUCT = 'providers/menuMaker/Products/DELETE_PRODUCT';
export const UPDATE_PRODUCT_IMAGE = 'providers/menuMaker/Products/UPDATE_PRODUCT_IMAGE';
export const GET_PRODUCTS_SCROLL_PAGINATION = 'providers/menuMaker/Products/GET_PRODUCTS_SCROLL_PAGINATION';
